import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import img1 from '../images/frontend.jpg'; 
import img2 from '../images/backend.jpg';
import img3 from '../images/wordpress.jpg';
import img4 from '../images/maintain.jpg';
import img5 from '../images/app.jpg';
import img6 from '../images/webtoapp.jpg';
import 'aos/dist/aos.css';
import AOS from 'aos';

const Service = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out', 
      once: false,
    });
  }, []);

  const serviceRefs = useRef([]);

  const services = [
    { img: img1, title: 'Frontend Development' },
    { img: img2, title: 'Backend Development' },
    { img: img3, title: 'WordPress Development' },
    { img: img4, title: 'WordPress Maintenance' },
    { img: img5, title: 'Mobile App Development' },
    { img: img6, title: 'Web-to-App Conversion' },
  ];

  const getDirection = (event, element) => {
    const rect = element.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const w = rect.width;
    const h = rect.height;

    const fromTop = y < h / 2 && x > y && x < w - y;
    const fromBottom = y > h / 2 && x > h - y && x < w - (h - y);
    const fromLeft = x < w / 2 && y > x && y < h - x;
    const fromRight = x > w / 2 && y > w - x && y < h - (w - x);

    if (fromTop) return 'top';
    if (fromBottom) return 'bottom';
    if (fromLeft) return 'left';
    if (fromRight) return 'right';
    return null;
  };

  const handleMouseEnter = (event, index) => {
    const direction = getDirection(event, serviceRefs.current[index]);
    const overlay = serviceRefs.current[index].querySelector('.overlay');
    const title = serviceRefs.current[index].querySelector('.title');

    let fromX = '0%';
    let fromY = '0%';

    switch (direction) {
      case 'top':
        fromY = '-100%';
        break;
      case 'bottom':
        fromY = '100%';
        break;
      case 'left':
        fromX = '-100%';
        break;
      case 'right':
        fromX = '100%';
        break;
      default:
        break;
    }

    gsap.fromTo(
      overlay,
      { x: fromX, y: fromY, opacity: 0 },
      { x: '0%', y: '0%', opacity: 0.9, duration: 0.3 }
    );
    gsap.fromTo(
      title,
      { x: fromX, y: fromY, opacity: 0 },
      { x: '0%', y: '0%', opacity: 1, duration: 0.3, delay: 0.1 }
    );
  };

  const handleMouseLeave = (event, index) => {
    const direction = getDirection(event, serviceRefs.current[index]);
    const overlay = serviceRefs.current[index].querySelector('.overlay');
    const title = serviceRefs.current[index].querySelector('.title');

    let toX = '0%';
    let toY = '0%';

    switch (direction) {
      case 'top':
        toY = '-100%';
        break;
      case 'bottom':
        toY = '100%';
        break;
      case 'left':
        toX = '-100%';
        break;
      case 'right':
        toX = '100%';
        break;
      default:
        break;
    }

    gsap.to(overlay, { x: toX, y: toY, opacity: 0, duration: 0.3 });
    gsap.to(title, { x: toX, y: toY, opacity: 0, duration: 0.3 });
  };

  return (
    <div className="flex flex-col justify-center items-center gap-4 pt-28 md:pt-16">
      <div className="flex flex-col items-center" data-aos="fade-up">
        <p className="text-2xl tracking-widest font-extrabold">OUR SERVICE</p>
        <span className="text-xs">(Hover over the image to view the service.)</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 lg:gap-6 mx-10 mb-10">
        {services.map((service, index) => (
          <div
            data-aos="zoom-in-up"
            key={index}
            className="relative w-full h-40 md:w-62 md:h-62 lg:w-96 lg:h-60 overflow-hidden cursor-pointer"
            onMouseEnter={(e) => handleMouseEnter(e, index)}
            onMouseLeave={(e) => handleMouseLeave(e, index)}
            ref={(el) => {
              if (el && !serviceRefs.current.includes(el)) {
                serviceRefs.current[index] = el;
              }
            }}
          >
            <img src={service.img} alt={service.title} className="w-full h-full object-cover" />
            <div className="overlay absolute inset-0 bg-[#00E6F6] opacity-0 z-10"></div>
            <div className="title absolute inset-0 flex justify-center items-center text-black text-md text-center md:text-xl font-bold opacity-0 z-20">
              {service.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
